import { Component, Input } from '@angular/core';
import { App_Tooltip } from 'src/app/utils/interfaces';

@Component({
  selector: 'app-c-popover-tooltip',
  templateUrl: './c-popover-tooltip.component.html',
  styleUrls: ['./c-popover-tooltip.component.scss'],
})
export class CPopoverTooltipComponent {
  @Input({ required: true }) tooltip!: App_Tooltip | undefined;

  constructor() { }

}
